import React from "react";
import { FormHelperText } from "@mui/material";
import { FONT_SECONDARY } from "@/theme/typography";

interface IProps {
  message: string;
}

const ErrorMessage: React.FC<IProps> = ({ message }) => {
  return (
    <FormHelperText
      sx={{
        fontFamily: FONT_SECONDARY,
        position: "absolute",
        bottom: "-16px",
        left: 0,
        zIndex: 50,
        fontSize: "0.625rem",
        color: '#D32F2F'
      }}
    >
      {message}
    </FormHelperText>
  );
};

export default ErrorMessage;
